// extracted by mini-css-extract-plugin
export default {"ScaleInput":"ScaleInput-module-d5f00a131ee7ef665cc3"};